import ButtonCard from "../UI/ButtonCard";
import IconAndText from "../UI/IconAndText";
import { useFormikContext } from "formik";
import { ReactSelect } from "../UI/Select";
import FormikSubmitButton from "../UI/FormikSubmitButton";
import useProcesses from "../../hooks/use-processes";
import useTenants from "../../hooks/use-tenants";
import { TenantStatus } from "../../models/tenant_old.js";

export default function ProcessChoice({ processType, text, icon }) {
  const { values, setFieldValue } = useFormikContext();
  const { activeProcesses } = useProcesses();
  const { tenants } = useTenants();

  const tenantOptions = tenants
    .filter((tenant) => tenant.status === TenantStatus.Actif.status)
    .filter(
      (tenant) =>
        !activeProcesses.some(
          (proc) => proc.id_tenant === tenant.id && proc.type === values.type,
        ),
    )
    .map((tenant) => ({ value: tenant.id, label: tenant.nom }));

  return (
    <>
      <ButtonCard
        onClick={() =>
          values.type === processType
            ? setFieldValue("type", null)
            : setFieldValue("type", processType)
        }
        className={"w-100 flex space-between align-items-center"}
        requiresWrite
      >
        <IconAndText text={text} icon={icon} />
      </ButtonCard>
      {values.type === processType && (
        <div className={"flex align-items-center gap10 wrap"}>
          <ReactSelect
            name={"id_tenant"}
            options={tenantOptions}
            className={"w-15em"}
          />
          <FormikSubmitButton requiresWrite>Valider</FormikSubmitButton>
        </div>
      )}
    </>
  );
}
